export default __webpack_public_path__ + "static/media/icon-insights-performance-email-marketing.f1692c4f.svg";